<template>
  <div>
    <form class="class_add_con w622 col_2_1" data-vv-scope="form" style="min-height: auto;">
      <table width="100%" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <td class="left_td">上级部门：</td>
          <td><input name="" type="text" class="search_put" disabled="disabled" v-model="form.parent.name" /><input name="" type="button" class="search_btn" @click="show1" /></td>
        </tr>
        <tr>
          <td class="left_td">名称：</td>
          <td><input type="text" name="name" v-validate="'required'" placeholder="请输入部门名称" class="put_495" style="width:180px;" v-model="form.name" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.name') }}</div>
        <tr>
          <td class="left_td">类型：</td>
          <td>
            <select name="type" class="all_select" v-validate="'required'" v-model="form.type">
              <option value="0">公司</option>
              <option value="1">部门</option>
              <option value="2">地区</option>
            </select>
          </td>
        </tr>
        <div class="error_msg">{{ errors.first('form.type') }}</div>
        <tr>
          <td class="left_td " valign="top">排序：</td>
          <td><input type="text" name="sort" v-validate="'required'" placeholder="请输入排序" class="put_495" style="width:180px;" v-model="form.sort" /></td>
        </tr>
        <div class="error_msg">{{ errors.first('form.sort') }}</div>
      </table>
      <div class="add_bt_foot">
        <input name="" type="button" value="保存" @click="validateForm('form')" />
        <input name="" class="hui_color" type="button" value="取消" @click="emit('closed')" />
      </div>
    </form>
  </div>
</template>

<script>
  import config from '@/config'
  import api from '@/api'
  import '@/utils/validator.js'
  import TreeSelect from '@/page/byl/sys/menu/treemenu.vue'
  import { mapState } from 'vuex'
  import Bus from '@/utils/bus.js'
  export default {
    props: ['data'],
    data () {
      return {
        menus: [],
        form: {
          parent: {}
        }
      }
    },
    watch: {
      data: {
        handler(val) {
          this.form = val
          if (val.newparent) { // 更换了上级菜单
            if (val.newparent.id == this.form.id) {
              this.form.parent = {name: ''}
              if (this.form.id) {
                this.popup('请不要选择当前部门作为上级部门')
              }
            } else {
              this.form.parent = val.newparent
            }
          } else { // 没有更换上级菜单
            if (val.parentName) {
              this.form.parent = {name: val.parentName, id: val.parentId, parentIds: val.parentIds}
            } else {
              this.form.parent = {name: ''}
            }
          }
        },
        deep: true
      }
    },
    created () {
    },
    mounted () {
      this.form.parent = this.dept // 新增状态下将“部门”赋值
    },
    computed: {
      ...mapState('orgstructure', ['dept'])
    },
    methods: {
      emit (msg, p) {
        this.$emit(msg, p)
      },
      popup (msg) {
        this.$toasted.show(msg)
      },
      confirmBox (o) {
        var that = this
        this.$modal.show('dialog', {
          title: '提交',
          text: '确认提交吗？',
          buttons: [
            {
              title: '确认',
              default: true,
              handler: () => {
                if (o.yes && o.yes instanceof Function) {
                  o.yes()
                  that.$modal.hide('dialog') // !!!必须清掉模态框，否则在别的页面按enter键会触发方法的
                }
              }
            },
            {
              title: '取消'
            }
          ]
        })
      },
      validateForm (scope) {
        var bus = this
        var _dealParams = function () { // 处理发送给后台的数据结构
          var _dealParentIds = function () {
            if (bus.form.parent.parentIds) {
              // console.log(bus.form.newparent)
              if (bus.form.newparent) { // 如果选择了新的上级, 重新拼接parentIds, 否则不变
                bus.form.parentIds = bus.form.parent.parentIds + ',' + bus.form.parent.id
                bus.form.parentIds = bus.$utils.arr2str(bus.form.parentIds.split(',').filter((o) => {
                  return o
                })) // 保证数据里的空值被过滤掉
              }
            } else { // 考虑上级菜单选择了“无”/什么都没选的情况
              bus.form.parentIds = bus.form.parent.id
              bus.form.parentName = ''
            }
          }
          bus.form.title = bus.form.name // 更新title
          if (bus.form.parent.id) { // 有了新的上级, 新上级的赋值在watch里
            bus.form.parentId = bus.form.parent.id
            bus.form.parentName = bus.form.parent.name
            _dealParentIds()
          } else { // 不选择任何上级菜单的情况默认“无”的状态
            if (!bus.form.level) { // 如果level已有，保持不变
              bus.form.parentId = '0'
              bus.form.parentIds = '0'
              bus.form.level = '1'
            }
          }
          if (bus.form.parent.level) {  // 新增/编辑的情况要重写level
            if (bus.form.parent.name == '无' && bus.form.parent.level == 1) { // 判断上级是“无”的情况
              bus.form.level = '1'
            } else {
              bus.form.level = '' + (Number(bus.form.parent.level) + 1)
            }
          }
        }
        this.$validator.validateAll(scope).then(function (result) {
          if (result) {
            bus.confirmBox({
              yes: function () {
                _dealParams()
                delete bus.form.parent
                delete bus.form.newparent
                bus.$emit('saved', bus.form)
                bus.$emit('closed')
                bus.$modal.hide('dialog')
              }
            })
          } else {
            bus.popup('请确保信息正确与完整')
            return false
          }
        })
      },
      show1 () {
        var that = this
        var _open = function (menus) {
          that.$modal.show(TreeSelect, {
            data: menus,
            selected: that.form.parent,
            yes: function (val) {
              if (that.form.parent) { delete that.form.parent }
              if (that.form.newparent) { delete that.form.newparent }
              that.$set(that.data, 'newparent', val[0]);
            }
          })
        }
        if (this.menus && this.menus.length > 0) {
          _open(this.menus)
        } else {
          this.getMenus().then((r) => {
            this.menus = r || []
            this.menus.unshift({ name: '无', title: '无', id: '0', parentId: '0', level: 1 }) // 允许上级菜单为“空”
            _open(this.menus)
          })
        }
      },
      getMenus (filters) {
        var that = this
        return new Promise(function (resolve, reject) {
          api.post(config.bylApiPath, '/dep/list', null, function (r) { // 获取正常
            resolve(r.data)
          })
        })
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/page/byl/org/structure/dept.vue